import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { FeaturesDisplayLayoutUI } from './FeaturesDisplayLayoutUI';
import { PriorityFeatures } from './PriorityFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BrandingAndLimitPriorityFeatures = ({
  brandingAndLimitFeatures,
  uncategorizedFeatures,
  handleClickFreeToolsWithLimitsLink,
  isCollapsible = false,
  isFreePortal
}) => {
  const HeaderSection = /*#__PURE__*/_jsx(View, {
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "pricing-pages-ui.merchCardsV2.priorityFeatures.freeToolsRemoveBranding",
      options: {
        freeToolsWithIncreasedLimits: isFreePortal ? /*#__PURE__*/_jsx(Link, {
          onClick: handleClickFreeToolsWithLimitsLink,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.merchCardsV2.priorityFeatures.freeToolsWithLimits"
          })
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.priorityFeatures.freeToolsWithLimits"
        })
      }
    })
  });
  const FeaturesListSection = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PriorityFeatures, {
      features: brandingAndLimitFeatures
    }), /*#__PURE__*/_jsx(View, {
      paddingBlockStart: "300",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.priorityFeatures.and"
      })
    }), /*#__PURE__*/_jsx(PriorityFeatures, {
      features: uncategorizedFeatures
    })]
  });
  return /*#__PURE__*/_jsx(FeaturesDisplayLayoutUI, {
    HeaderSection: HeaderSection,
    FeaturesListSection: FeaturesListSection,
    isCollapsible: isCollapsible
  });
};